import { SSO_REQUEST } from '../constants/sso.constants';

export const ssoAction = ssotoken => ({
  type: SSO_REQUEST,
  payload: { ssotoken },
});
